module.exports = __webpack_public_path__ + "6d821b440e7f4a83822f09bf676b5efa.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/iconos/misenvios.png
// module id = 2158
// module chunks = 0